<ng-template [ngIf]="isVerificandoConsegna">
  <app-loading></app-loading>
</ng-template>
<p-steps [model]="pagineValidaConsegna" [readonly]="true" [activeIndex]="activeIndex" >  </p-steps> 
   <div class="d-flex mt-1 ">
    <ng-container [ngSwitch]="activeIndex">
      <ng-container *ngSwitchCase="0">
        <form [formGroup]="verificaVerbaleForm">
          <div class="grid formgrid p-fluid ">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormVerbale()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="regione"  binary="true"  inputId="checkboxRegione" > </p-checkbox>
              <label for="checkboxRegione" class="ml-1 mb-0" style="font-size: 11px;">La regione è <span class="font-semibold">{{pratica.regione.toUpperCase()}}</span></label>
            </div>
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="provincia"  binary="true"  inputId="checkboxProvicina" > </p-checkbox>
              <label *ngIf="pratica.provincia" for="checkboxProvicina" class="ml-1 mb-0" style="font-size: 11px;">La provincia è <span class="font-semibold">{{pratica.provincia.toUpperCase()}}</span></label>
              <label *ngIf="!pratica.provincia" for="checkboxProvicina" class="ml-1 mb-0" style="font-size: 11px;">La provincia è corretta</label>
            </div>
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="comune"  binary="true"  inputId="checkboxComune" > </p-checkbox>
              <label for="checkboxComune" class="ml-1 mb-0" style="font-size: 11px;">Il comune è <span class="font-semibold">{{pratica.comune.toUpperCase()}}</span></label>
            </div>
            <div class="field col-3 flex align-items-center  mt-2">
              <p-checkbox formControlName="indirizzo"  binary="true"   inputId="checkboxIndirizzo" > </p-checkbox>
              <label for="checkboxIndirizzo" class="ml-1 mb-0" style="font-size: 11px;">L'indirizzo è <span class="font-semibold">{{pratica.indirizzo.toUpperCase()}}</span></label>
            </div>
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="cui"  binary="true"   inputId="checkboxCUI" > </p-checkbox>
              <label for="checkboxCUI" class="ml-1 mb-0" style="font-size: 10px;">Il CUI è <span class="font-semibold">{{pratica.cui}}</span></label>
            </div>
            <div class="field col-3 flex align-items-center">
              <p-checkbox formControlName="denominazione"  binary="true"   inputId="checkboxDenominazione" > </p-checkbox>
              <label for="checkboxDenominazione" class="ml-1 mb-0" style="font-size: 11px;">Il nome della scuola è <span class="font-semibold">{{pratica.denominazione.toUpperCase()}}</span></label>
            </div>
            
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="coordinate"  binary="true"   inputId="checkboxCoordinate" > </p-checkbox>
             <label for="checkboxCoordinate" class="ml-1 mb-0" style="font-size: 11px;">Le <b>coordinate</b> sono corrette</label>
            </div>
            <div class="field col-3 flex align-items-center mt-2">
              <p-checkbox formControlName="tipologiaEffettiva"  binary="true"  inputId="checkboxTipologiaGara" > </p-checkbox>
              <label for="checkboxTipologiaGara" class="ml-1 mb-0" style="font-size: 11px;">La <b>sede</b> è di tipo <span class="font-semibold">{{pratica.tipoSedeEffettiva.toUpperCase()}}</span></label>
            </div>
           
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="correttezzaIPv4"  binary="true"   inputId="checkboxIP" > </p-checkbox>
              <label for="checkboxIP" class="ml-1 mb-0" style="font-size: 11px;"><b>L'indirizzo IP</b> statico è corretto</label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="coerenzaSpeedTest"   binary="true"  inputId="checkboxSpeedtest" > </p-checkbox>
              <label for="checkboxSpeedtest" class="ml-1 mb-0" style="font-size: 11px;">I dati dello <b>speed test</b> sono coerenti</label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="coerenzaPingTest"   binary="true"  inputId="checkboxPingTest" > </p-checkbox>
              <label for="checkboxPingTest" class="ml-1 mb-0" style="font-size: 11px;">I dati del <b>ping test</b> sono coerenti</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="backup"  binary="true"   inputId="checkboxBackup" > </p-checkbox>
              <label for="checkboxBackup" class="ml-1 mb-0" style="font-size: 11px;">Il <b>backup</b> indicato è corretto</label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="wifi"  binary="true"   inputId="checkboxWifi" > </p-checkbox>
              <label for="checkboxWifi" class="ml-1 mb-0" style="font-size: 11px;">Il <b>WIFI</b> indicato è corretto</label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="posizionamentoRouter"   binary="true"  inputId="checkboxPosizioneRouter" > </p-checkbox>
              <label for="checkboxPosizioneRouter" class="ml-1 mb-0" style="font-size: 11px;">Il <b>piano</b> e la <b>stanza</b> di installazione del router sono presenti</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="firmato"  binary="true"   inputId="checkboxFirmatoDaScuola" > </p-checkbox>
              <label for="checkboxFirmatoDaScuola" class="ml-1 mb-0" style="font-size: 11px;">Il verbale è firmato dal <b>dirigente</b> o dal <b>delegato</b></label>
            </div>
            <div class="field col-4 flex align-items-center mt-2">
              <p-checkbox formControlName="coerenzaData"   binary="true"  inputId="checkboxData" > </p-checkbox>
              <label for="checkboxData" class="ml-1 mb-0" style="font-size: 11px;">La <span class="font-semibold">data di attivazione</span> è corretta</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-12">
              <label for="noteVerbale" style="font-size: 11px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteVerbale" rows="3" [autoResize]="true" formControlName="noteVerbale" pInputTextarea></textarea>
              </span>
            </div>
            
          </div>
        </form>
      </ng-container>
       <ng-container *ngSwitchCase="1">
        <form [formGroup]="verificaAllegatieForm">
          <div class="grid formgrid p-fluid">
            <div class="field col-12 flex justify-content-start align-items-center mt-2 highlight-checkbox">
              <p-checkbox 
                formControlName="selectAll" 
                binary="true" 
                inputId="selectAllCheckbox" 
                (onChange)="toggleAllFieldsFormAllegati()">
              </p-checkbox>
              <label for="selectAllCheckbox" class="ml-2 mb-0" >
                SELEZIONA/DESELEZIONA TUTTI
              </label>
            </div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="modemVisibile"  binary="true"   inputId="checkboxFotoRouter" > </p-checkbox>
              <label for="checkboxFotoRouter" class="ml-1 mb-0" style="font-size: 11px;">Nella foto del CPE <b>il router</b> <i>è visibile</i></label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="pingAlmeno1000Pacchetti"  binary="true"   inputId="checkboxCoerenzaPingtest" > </p-checkbox>
              <label for="checkboxCoerenzaPingtest" class="ml-1 mb-0" style="font-size: 11px;">Dalla foto/screenshot del <b>PING test</b> si evince che è stato eseguito su almeno <i>{{numeroPacchetti}} pacchetti</i></label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>
            <div class="field col-12 flex align-items-center mt-2">
              <p-checkbox formControlName="speedTestRispettaRequisiti"  binary="true"   inputId="checkboxCoerenzaSpeedtest" > </p-checkbox>
              <label for="checkboxCoerenzaSpeedtest" class="ml-1 mb-0" style="font-size: 11px;">Dalla foto/screenshot dello <b>SPEED test</b> si evince che la <i>velocità di connessione</i> è quella richiesta dal bando</label>
            </div>
            <div class="surface-border border-top-1 opacity-50 mt-1 mb-3 col-12"></div>

            <div class="field col-12">
              <label for="noteAllegati" style="font-size: 11px;">Note</label>
              <span class="p-input-icon-left">
                <i class="pi pi-info-circle"></i>
                <textarea id="noteAllegati" rows="3" [autoResize]="true" formControlName="noteAllegati" pInputTextarea></textarea>
              </span>
            </div>
          </div>
        </form>
      </ng-container> 
     
    </ng-container>
   </div>

    <div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
    <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
       <p-button icon="pi pi-arrow-left" class="p-button-text mr-2" (click)="activeIndex = activeIndex - 1" [disabled]="activeIndex === 0 "></p-button>
        <p-button icon="pi pi-arrow-right" class="p-button-text mr-1" (click)="changePage()" [disabled]="checkNextStep()"></p-button>
        <p-button  icon="pi pi-check" label="Conferma" class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isVerificandoConsegna"></p-button>
    </div>
    <p-toast />
    <p-confirmDialog /> 